import React from 'react';
import { Box, Typography } from '@mui/material';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, SUBTLE } from '../../styles/foundation/colors';

/** Title + one-line hint above a row of KPI cards on the PTL Visibility pages. */
export default function SectionHeading({ title, hint, sx }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap', mb: 1.25, ...sx }}>
      <Typography sx={{ fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.bold, color: NAVY }}>{title}</Typography>
      {hint && <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE }}>{hint}</Typography>}
    </Box>
  );
}
